<template>
  <div
    class="flex select-none flex-row place-items-center text-gray-800 dark:text-gray-400 cursor-pointer"
    :class="{ 'cursor-not-allowed': disabled }"
  >
    <input @input="onInput" type="checkbox" :checked="checked" :disabled="disabled" />
    <label v-if="label" class="ml-1">{{ label }}</label>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['update:checked'])

defineProps<{
  label: string,
  checked: boolean,
  disabled?: boolean
}>()

const onInput = (event) => emit('update:checked', (event.target as HTMLInputElement).checked)

</script>

<style scoped></style>
